'use client';

import { lazy, Suspense, useEffect, useState } from 'react';
import TokenInitializer from '@/components/token-initializer';
import TokenInitializedGuard from '@/components/token-initialized-guard';
import Header from '@/components/layout/header';
import DownloadPosterProvider from '@/features/referral/components/ReferralPosterProvider';
import TransferPackageProvider from '@/features/transfer-package/provider';
import GlobalModalProvider from '@/components/modal/provider';

const FloatingBall = lazy(() => import('@/features/ranking/components/FloatingBall'));
const AppVersionUpdateProvider = lazy(() => import('@/features/app-version/provider'));

function DelayedFloatingBall() {
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShouldRender(true);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  if (!shouldRender) {
    return null;
  }

  return <FloatingBall />;
}

export default function MainLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <>
      <div id="main-layout" className="relative flex flex-col h-full bg-[#101218]">

        <TokenInitializer />
        <TokenInitializedGuard>
          <Header />
          <Suspense
            fallback={
              <main className="flex-1 relative min-h-full">
                <Suspense>{children}</Suspense>
              </main>
            }
          >
            {children}
          </Suspense>
          <GlobalModalProvider />
          {/* 转移包 */}
          <Suspense fallback={null}>
            <TransferPackageProvider />
          </Suspense>
          {/* 版本更新 */}
          <Suspense fallback={null}>
            <AppVersionUpdateProvider />
          </Suspense>
        </TokenInitializedGuard>
      </div>
      {/* 全局悬浮球 */}
      <DelayedFloatingBall />
      {/* 全局下载海报提供者（按需渲染） */}
      <DownloadPosterProvider />
    </>
  );
}